import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { QualityControlSubWorkOrder } from '../../../../common/quality-control/model/sub-work-order-qc.ts';
import { SchedulerStageItemService } from '../../../../views/scheduler-stage/services/item.service';
import {
  SchedulerStageRegisterProgressComponent,
  SchedulerStageRegisterProgressTypes,
} from '../../../../views/scheduler-stage/dialog/finish-stage/finish-stage.component';
import { HosesBomDetailsComponent } from '@dep-hoses/dialog/bom-details';
import { HosesInspectionRegisterDialogComponent } from 'src/app/views/scheduler-stage/dialog/hoses-inspection-stage/hoses-inspection-stage.component';

@Injectable()
export class HosesTrimmingItemService extends SchedulerStageItemService {
  override registerProgress(
    item: QualityControlSubWorkOrder
  ): Observable<QualityControlSubWorkOrder> {
    if (!item) {
      return;
    }
    return this.registerProgressDialog(item).pipe(
      switchMap((res) => {
        return this.registerProgressReport(item, res, true);
      })
    );
  }

  protected registerProgressDialog(
    itemSelected: QualityControlSubWorkOrder
  ): Observable<SchedulerStageRegisterProgressTypes['return']> {
    const currentStageName = itemSelected.stage?.title;
    if (currentStageName === 'Hoses Inspection') {
      return this.dialog
        .open(HosesInspectionRegisterDialogComponent, {
          data: {
            maxQuantity: itemSelected.quantity,
            title: itemSelected.title,
            department: this.departmentService.NAME,
            operatorType: 'Operador',
          },
          minWidth: '50%',
        })
        .afterClosed()
        .pipe(filter((data) => !!data));
    } else if (currentStageName === 'Trimming') {
      return this.dialog
        .open(SchedulerStageRegisterProgressComponent, {
          data: {
            maxQuantity: itemSelected.quantity,
            title: itemSelected.title,
            department: this.departmentService.NAME,
            operatorType: 'Auxiliar',
          },
          minWidth: '50%',
        })
        .afterClosed()
        .pipe(filter((data) => !!data));
    }
  }

  // protected registerProgressReport(
  //   itemSelected: QualityControlSubWorkOrder,
  //   res: SchedulerStageRegisterProgressTypes['return']
  // ): Observable<QualityControlSubWorkOrder> {
  //   return this.apiStageRouter.finishSubWorkOrderStage({
  //     itemId: itemSelected.workOrderId,
  //     stageId: itemSelected.stageId,
  //     quantity: res.quantity,
  //     scrapReasons: res.scrapReasons,
  //     shiftId: res.shiftId,
  //     toValidation: false,
  //     nextStage: 'Quality Control',
  //     operators: res.operatorId
  //       ? [
  //           {
  //             operatorId: res.operatorId,
  //           },
  //         ]
  //       : undefined,
  //   });
  // }
  override showBom(item: QualityControlSubWorkOrder): void {
    this.dialog.open(HosesBomDetailsComponent, {
      data: {
        searching: item.workOrderId,
        query: 'destination=true',
        itemName: item.assemblyTitle,
      },
    });
  }
}
